import { render } from "./ecuDetail.vue?vue&type=template&id=1b8af00e&scoped=true&ts=true"
import script from "./ecuDetail.vue?vue&type=script&lang=ts"
export * from "./ecuDetail.vue?vue&type=script&lang=ts"

import "./ecuDetail.vue?vue&type=style&index=0&id=1b8af00e&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8af00e"]])

export default __exports__